import styled from 'styled-components';
import { variables } from '../../../styles/variables';

export const StyledApp = styled('div')`
  background-color: ${variables.colorBackground};
  height: 100vh;
    .top_frame_children {
      flex-direction: column-reverse;
      justify-content: space-between;
      button:not([class="btn"]) {
        font-weight: 300;
        letter-spacing: 0.05rem;
        margin-top: 10px;
        width: 100%;
      }
      @media (max-width: 786px), (max-height: 567px) {
        flex-direction: row-reverse;
        width: 100%;
        justify-content: space-between;
        button:not([class="btn"]) {
          width: max-content;
        }
      }
      @media (max-width: 400px) {
        flex-direction: column-reverse;
      }
    }
    .ant-table-cell {
      button.ant-table-row-expand-icon{
        border-color: #b9b9b9 !important;
      }
    }
    .table__subjectsCards {
      .ant-spin-text {
        display: none;
      }
    }
    .table__subjectsCards .ant-table-tbody > tr > td:first-child {
      min-width: 150px;
      max-width: 300px;
    }

`;

export const TabsContainer = styled('div')`
  padding-top: 20px;
  margin: 0 auto;
  max-width: calc(100vw - 40px);
  @media (max-width: 668px) {
    max-width: calc(100vw - 15px);
    margin: 0 auto;
  }
`;
